<template>
  <v-app>
    <template v-if="isLoading">
      TRWA ŁADOWANIE...
    </template>
    <!--<v-container grid-list-md text-xs-center>-->
    <!--<v-layout row wrap>-->
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <!--</v-layout>-->
    <!--</v-container>-->
  </v-app>
</template>

<script>

  export default {
    name: 'app',
    data() {
      return {
        isLoading: true,
        settings: null
      }
    },
    mounted() {
      this.isLoading = false;

      if (localStorage.getItem('settings')) this.settings = JSON.parse(localStorage.getItem('settings'));
      if (this.settings==null || this.settings.myWeight === null) {
        // this.$router.push({name: 'setWeight', params: {myWeight:this.myWeight}})
        this.$router.push({name: 'setWeight'})
      }
    },
    // watch: {
    //   myWeight: {
    //     handler() {
    //       console.log('myWeight changed!');
    //       localStorage.setItem('myWeight', JSON.stringify(this.myWeight));
    //     },
    //     deep: true,
    //   },
    // },


  }
</script>

<style>
  body {
    margin: 0;
    -webkit-overflow-scrolling: auto !important;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*color: #2c3e50;*/
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }

  .slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
  {
    transform: translateX(10px);
    opacity: 0;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue